import toFixed from './to-fixed';
export function bytesToKiloBytes(bytes) {
    return toFixed(bytes / Math.pow(10, 3));
}
export function bytesToMegaBytes(bytes) {
    return toFixed(bytes / Math.pow(10, 6));
}
